import { useState } from 'react'
import { IVerifyPhoneRegistrationInput } from '~/@api/generated-api-types/global.types'
import { useAlert } from '~/@ui/alert/useAlert'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'

declare global {
  interface Window {
    dataLayer: any[]
  }
}

export const useRegVerVerify = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { showAlert } = useAlert()

  const verifyVerify = async (data: IVerifyPhoneRegistrationInput) => {
    setIsLoading(true)
    try {
      const { data: response } =
        await getApi().userAuthAppApiControllerVerifyPhoneRegistrationWithJwt(
          data
        )

      if ('success' in response) {
        showAlert('success', 'Verifikácia tel. čísla prebehla úspešne')
        return response
      }

      throw new Error('Nastala neznáma chyba pri overovaní tel. čísla.')
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    } finally {
      setIsLoading(false)
    }
  }

  return { verifyVerify, isLoading }
}
